
const initState = {
    type: '',
    downloadList: [],
    containerList: [],
    error: null
}

const containerReducer = (state = initState, action) => {

    switch (action.type) {
        case 'CONTAINER_LIST_PENDING': return { ...state, type: action.type, error: null }
        case 'CONTAINER_LIST_SUCCESS': return { ...state, type: action.type, error: null, containerList: action.payload }
        case 'CONTAINER_LIST_ERROR': return { ...state, type: action.type, error: action.payload }
        case "SET_CONTAINER_LIST": {
            return { ...state, containerList: action.payload }
        }
        case "SET_DOWNLOAD_LIST": {
            return { ...state, downloadList: action.payload }
        }

        default: return state;
    }
};

export default containerReducer;